import { assertInInjectionContext, inject, Injector, runInInjectionContext } from '@angular/core';
import { EventTypes, PublicEventsService } from 'angular-auth-oidc-client';
import { filter, map, Observable, of, pipe, switchMap, take, tap, UnaryFunction } from 'rxjs';
import { LoggerWithConfigurationService } from '../service/internal/logger-with-configuration.service';
import { checkIfRefreshIsRequired } from './check-if-refresh-is-required';
import { createPrefixMessage } from './prefix-message.function';

export function waitForAuthentication<T>(
  injector?: Injector,
): UnaryFunction<Observable<T>, Observable<T>> {
  if (!injector) {
    assertInInjectionContext(waitForAuthentication);
    injector = inject(Injector);
  }
  return runInInjectionContext(injector, () => {
    const prefixMessage = createPrefixMessage('waitForAuthentication');
    const publicEventsService = inject(PublicEventsService);
    const loggerService = inject(LoggerWithConfigurationService);
    return pipe(
      switchMap((value: T) =>
        of(value).pipe(
          tap(() => {
            loggerService.logDebug(prefixMessage(`Waiting for authentication to complete.`));
          }),
          checkIfRefreshIsRequired(injector),
          switchMap((refreshIsRequired) => {
            if (!refreshIsRequired) {
              return of(value);
            }
            return publicEventsService.registerForEvents().pipe(
              filter((notification) => {
                return notification.type === EventTypes.NewAuthenticationResult;
              }),
              take(1),
              map(() => value),
            );
          }),
          tap(() => {
            loggerService.logDebug(prefixMessage(`Authentication completed continuing.`));
          }),
        ),
      ),
    );
  });
}
